module.exports = __webpack_public_path__ + "fonts/Cute-Aurora-2.9fd0e398.ttf";